import { Button, Result } from "antd";

import React from "react";
import styled from "styled-components";

const ResultContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  padding: 20px;
  
  .ant-result {
    max-width: 640px;
    
    .ant-result-subtitle {
      font-size: 1.6rem;
    }
  }
`;

const AccessDenied: React.FC = () => {
    const handleContactSupport = () => {
        window.location.href = "mailto:rooam.support@aexp.com?subject=Middleware Connect Dashboard Access Request";
    };

    const handleReturnToLogin = () => {
        // Remove debug parameter and reload
        const url = new URL(window.location.href);
        url.searchParams.delete("debug");
        window.location.href = url.toString();
    };

    // Check if we're in debug mode
    const isDebugMode = window.location.search.includes("debug=unauthorized");

    return (
      <ResultContainer>
        <Result
          status="403"
          title={isDebugMode ? "Access Denied (Debug Mode)" : "You don't have access to this application"}
          subTitle={
            isDebugMode
              ? "You are simulating an access denied state for testing and debugging purposes."
              : "Your account was authenticated successfully, but you don't have permission to access this application. If you believe this is a mistake, please contact support."
          }
          extra={[
            <Button
              type="primary"
              key="contact"
              onClick={handleContactSupport}>
                Contact Support
            </Button>,
            <Button
              type="default"
              key="retry"
              onClick={isDebugMode ? handleReturnToLogin : () => window.location.reload()}>
              {isDebugMode ? "Exit Debug Mode" : "Try Again"}
            </Button>
          ]}
        />
      </ResultContainer>
    );
};

export default AccessDenied;